<script lang="ts" setup>
import { computed } from 'vue';
import useChorusStore from '../../store/Chorus';

const chorusStore = useChorusStore();

const invoice = computed(() => chorusStore.selected[0]);
</script>

<template>
  <div class="px-6 py-6 bg-gray-50">
    <div class="space-y-6">
      <!-- Section Détails -->
      <div class="space-y-4">
        <h3 class="text-sm font-semibold text-gray-900 uppercase tracking-wider border-b border-gray-200 pb-2">
          Détails de la facture
        </h3>

        <!-- Destinataire -->
        <div class="bg-white rounded-lg p-4 border border-gray-200">
          <div class="space-y-3">
            <div>
              <label class="block text-xs font-medium text-gray-500 uppercase tracking-wider">
                Destinataire
              </label>
              <p class="text-sm font-medium text-gray-900 mt-1">
                {{ invoice.recipient ? invoice.recipient.name : "Aucun destinataire" }}
              </p>
            </div>

            <div>
              <label class="block text-xs font-medium text-gray-500 uppercase tracking-wider">
                Titre
              </label>
              <p class="text-sm font-medium text-gray-900 mt-1">
                {{ invoice.title }}
              </p>
            </div>
          </div>
        </div>

        <!-- Numéros de commande et marché -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="bg-white rounded-lg p-4 border border-gray-200">
            <label class="block text-xs font-medium text-gray-500 uppercase tracking-wider">
              Numéro de commande
            </label>
            <p class="text-sm font-medium text-gray-900 mt-1">
              {{ invoice.commitmentNumber ? invoice.commitmentNumber : 'Non renseigné' }}
            </p>
          </div>

          <div class="bg-white rounded-lg p-4 border border-gray-200">
            <label class="block text-xs font-medium text-gray-500 uppercase tracking-wider">
              Numéro de marché
            </label>
            <p class="text-sm font-medium text-gray-900 mt-1">
              {{ invoice.contractNumber ? invoice.contractNumber : 'Non renseigné' }}
            </p>
          </div>
        </div>

        <!-- Montants -->
        <div class="bg-white rounded-lg p-4 border border-gray-200">
          <label class="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-3">
            Montants
          </label>
          <div class="grid grid-cols-3 gap-4">
            <div class="text-center">
              <p class="text-xs text-gray-500 uppercase tracking-wider">
                Total HT
              </p>
              <p class="text-lg font-semibold text-gray-900 mt-1">
                {{ invoice.totalNet.toFixed(2) }} €
              </p>
            </div>
            <div class="text-center">
              <p class="text-xs text-gray-500 uppercase tracking-wider">
                TVA
              </p>
              <p class="text-lg font-semibold text-gray-900 mt-1">
                {{ invoice.totalTax.toFixed(2) }} €
              </p>
            </div>
            <div class="text-center">
              <p class="text-xs text-gray-500 uppercase tracking-wider">
                Total TTC
              </p>
              <p class="text-lg font-bold text-blue-333 mt-1">
                {{ invoice.total.toFixed(2) }} €
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Section Historique -->
      <div class="space-y-4">
        <h3 class="text-sm font-semibold text-gray-900 uppercase tracking-wider border-b border-gray-200 pb-2">
          Historique
        </h3>

        <div class="space-y-3">
          <!-- Contrôle -->
          <div
            v-if="invoice.verifiedAt"
            class="bg-white rounded-lg p-4 border border-gray-200"
          >
            <div class="flex items-start space-x-3">
              <div class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <fa
                  :icon="['fas', 'check']"
                  class="w-4 h-4 text-green-600"
                />
              </div>
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-gray-900">
                  Facture contrôlée
                </p>
                <p class="text-xs text-gray-500 mt-1">
                  Le {{ new Date(invoice.verifiedAt).toLocaleDateString('fr-FR') }}
                  par {{ invoice.verifiedBy?.familyName }} {{ invoice.verifiedBy?.givenName }}
                </p>
              </div>
            </div>
          </div>

          <!-- Création -->
          <div
            v-if="invoice.createdAt"
            class="bg-white rounded-lg p-4 border border-gray-200"
          >
            <div class="flex items-start space-x-3">
              <div class="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <fa
                  :icon="['fas', 'plus']"
                  class="w-4 h-4 text-blue-600"
                />
              </div>
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-gray-900">
                  Facture créée
                </p>
                <p class="text-xs text-gray-500 mt-1">
                  Le {{ new Date(invoice.createdAt).toLocaleDateString('fr-FR') }}
                  par {{ invoice.createdBy?.familyName }} {{ invoice.createdBy?.givenName }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
